import { defineMessages } from 'react-intl';

const messages = defineMessages({
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  annualGowthRateCloudInstanceTitle: {
    id: 'DHpDOj',
    defaultMessage: 'Annual growth rate cloud instances:',
  },
  environments: {
    id: 'JEgVUq',
    defaultMessage: 'Environments',
  },
  attendedBots: {
    id: '9LKt55',
    defaultMessage: 'Attended Bots',
  },
  numberOfHoursPerWeekDescTooltip: {
    id: '0ET8UF',
    defaultMessage:
      'Please enter the average number of hours spent by all process users when executing the business processes you are looking to automate. ie: if 5 employees spend 10 hours a week on average on a process, enter 50 hours.',
  },
  fullTimeEmployeeCostHeadTooltip: {
    id: 'dhMdA+',
    defaultMessage: 'Full time employee cost',
  },
  errorrateHeadTooltip: {
    id: 'lxjxGd',
    defaultMessage: 'Error rate',
  },
  estimatedRoi: {
    id: 'hxKOo2',
    defaultMessage: 'Estimated ROI',
  },
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  resultsHeader: {
    id: 'Jr3wry',
    defaultMessage: 'Recommended Configuration',
  },
  footnoteOne2: {
    id: 'y2U0ZP',
    defaultMessage:
      'Cost and hour savings based on average historical FTE hour reduction of 90% for IBM RPA business processes. Your savings may differ based on the details of the process you wish to automate with IBM RPA. Certain factors such as RPA configuration, add-ons, and discounts may affect savings.',
  },
  ErrorRateDescTooltip: {
    id: '53buSE',
    defaultMessage:
      'Human error accounts for a significant source of delays and expenses that IBM RPA can help eliminate. Enter your best estimate of the average error rate for a process.',
  },
  calculationMessage: {
    id: 'HJ6tmW',
    defaultMessage: 'Cost savings for 1 year',
  },
  currentFullTimeEmployeeCostlabel: {
    id: 'cIqNED',
    defaultMessage: 'Full time employee cost (yearly):',
  },
  numberOfBusinessProcessToAutomateDescTooltip: {
    id: '/c0UHx',
    defaultMessage:
      'Enter the inital approximated number of process to automate.',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  returnToEstimator: {
    id: '1fHL/5',
    defaultMessage: 'Return to ROI estimator',
  },
  numberOfBusinessProcessToAutomate: {
    id: 'aCJm7A',
    defaultMessage:
      'How many business processes are you looking to automate in the first year?:',
  },
  numberOfHoursPerWeekTitle: {
    id: '5wxeyl',
    defaultMessage: 'Number of hours per week',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  widgetInfo: {
    id: 'XstqP4',
    defaultMessage:
      'IBM Robotic Process Automation experts will work with you to reach your business goals.',
  },
  errorRateTitle: {
    id: 'lxjxGd',
    defaultMessage: 'Error rate',
  },
  fullTimeEmployeeCostTitle: {
    id: '63hWA+',
    defaultMessage: 'Full time employee cost (yearly)',
  },
  roiPercentageMessage: {
    id: 'FvVmdo',
    defaultMessage: 'ROI Percentage',
  },
  availableIn: {
    id: '2eNCKb',
    defaultMessage: 'The Robotic Process Automation estimator is available in',
  },
  monthlyTimeSavingsMessage: {
    id: 'l8kRBr',
    defaultMessage: 'Monthly Time Savings',
  },
  additionalSavingsMessage: {
    id: 'RrRi3S',
    defaultMessage: 'Additional savings from rework reduction',
  },
  hoursMessage: {
    id: 'j9Y9nu',
    defaultMessage: 'Hours',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  errorRateLabel: {
    id: 'SXcT0c',
    defaultMessage: 'Error rate:',
  },
  numberOfBusinessProcessToAutomateHeadTooltip: {
    id: 'ArEolt',
    defaultMessage: 'Initial number of processes to automate',
  },
  gePEButton: {
    id: 'XYErDQ',
    defaultMessage: 'Deployment options and pricing',
  },
  fullTimeEmployeeCostDescTooltip: {
    id: '4JE80A',
    defaultMessage:
      'Estimate the average yearly compensation of process users to get a more accurate estimate of cost savings.',
  },
  numberOfHoursPerWeekHeadTooltip: {
    id: '5wxeyl',
    defaultMessage: 'Number of hours per week',
  },
  widgetText_1: {
    id: 'vd1Glm',
    defaultMessage:
      'Estimate your IBM Robotic Process Automation return on investment (ROI) today',
  },
  totalNumberOfBusinessProcessToAutomateTitle: {
    id: 'gaFoQW',
    defaultMessage:
      'Initial number of business processes to automate in the first year',
  },
  widgetText_2: {
    id: 'fRudYF',
    defaultMessage:
      'Please enter the estimated average values of your business process(es).',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  unattendedBots: {
    id: 'kPVEOb',
    defaultMessage: 'Unattended Bots',
  },
  footnoteOne: {
    id: 'NfhdQB',
    defaultMessage:
      'Cost and hour savings based on average historical FTE hour reduction of 95% for IBM RPA business processes. Your savings may differ based on the details of the process you wish to automate with IBM RPA. Certain factors such as RPA configuration, add-ons, and discounts may affect savings.',
  },
  numberOfHoursPerWeekLabel: {
    id: 'YorGzj',
    defaultMessage: 'Number of hours per week:',
  },
  asteriskPrice: {
    id: 'ESKVlc',
    defaultMessage:
      'Estimated prices do not include tax and are mostly intended for new Robotic Procees Automation, initial purchase only.',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
});

export default messages;
